//#region src/constants.ts
const APP_FETCH_OPTIONS = "app-fetch-options";
/**
* 微应用标签名
*/
const MICRO_APP_TAG_NAME = "micro-app-peerup-suite";
/**
* suite-app 事件前缀
*/
const SUITE_APP_EVENT_PREFIX = "Event:";
/**
* suite-app 指定支持的组件类型
*/
let SuiteAppType = /* @__PURE__ */ function(SuiteAppType) {
	/**
	* vue-demo组件
	*/
	SuiteAppType["VUE_DEMO"] = "vue-demo";
	/**
	* react-demo组件
	*/
	SuiteAppType["REACT_DEMO"] = "react-demo";
	/**
	* accounts组件
	*/
	SuiteAppType["ACCOUNTS"] = "accounts";
	/**
	* draw-app组件
	*/
	SuiteAppType["DRAW_APP"] = "draw-app";
	/**
	* workflow组件
	*/
	SuiteAppType["WORKFLOW"] = "workflow";
	/** 科研预约组件 */
	SuiteAppType["SAMPLE"] = "sample-app";
	return SuiteAppType;
}({});
/**
* suite-app 调用事件前缀
*/
const SUITE_APP_CALL_EVENT = "call";
/**
* suite-app 返回事件前缀
*/
const SUITE_APP_RETURN_EVENT = "return";
//#endregion
//#region src/helper/base.ts
const isError = (result) => {
	if (!result) return false;
	return result instanceof Error || typeof result === "object" && "name" in result && "message" in result && typeof result.name === "string" && typeof result.message === "string" && Object.prototype.toString.call(result) === "[object Error]";
};
/**
* @deprecated
*/
let messageIndex = Date.now();
/**
* @deprecated
*/
const composeCallPath = (params) => {
	const { method, to, from } = params;
	const currMessageIndex = messageIndex++;
	return {
		callPath: `${SUITE_APP_CALL_EVENT}/${method}?to=${to}&from=${from}&index=${currMessageIndex}`,
		returnPath: `${SUITE_APP_RETURN_EVENT}/${method}?to=${from}&from=${to}&index=${currMessageIndex}`
	};
};
/**
* @deprecated
*/
const parseCallEvent = (event) => {
	const eventObj = new URL(event);
	const handlePath = eventObj.pathname;
	const isCall = handlePath.startsWith(SUITE_APP_CALL_EVENT);
	const method = handlePath.slice((isCall ? SUITE_APP_CALL_EVENT : SUITE_APP_RETURN_EVENT).length + 1);
	const to = eventObj.searchParams.get("to");
	const from = eventObj.searchParams.get("from");
	const index = eventObj.searchParams.get("index");
	return {
		isCall,
		method,
		to,
		from,
		index,
		returnEvent: `${`${isCall ? SUITE_APP_RETURN_EVENT : SUITE_APP_CALL_EVENT}/${method}`}?to=${from}&from=${to}&index=${index}`
	};
};
//#endregion
export { MICRO_APP_TAG_NAME as a, SUITE_APP_RETURN_EVENT as c, APP_FETCH_OPTIONS as i, SuiteAppType as l, isError as n, SUITE_APP_CALL_EVENT as o, parseCallEvent as r, SUITE_APP_EVENT_PREFIX as s, composeCallPath as t };
